import { styled, Typography } from '@mui/material';
import { colors } from 'theme/colors';

export const StyledLink = styled(Typography)`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: ${colors.primary500};
  cursor: pointer;
`;
